import React from "react";
import {
  Text,
  Spacer,
  Video,
  TextSmall,
  Subtitle,
} from "../dynamic.components";
import mixinig_video from "src/assets/videos/mixing.mp4";
import SubHotspots from "../Sub-hotspots";

export const BagKart = () => (
  <>
    <Text text="The Bagkart™ is used for 2D bags from 1 to 20 L. It contains a loadcell to enable process monitoring within UNICORN™ control software." />
    <Subtitle color="green" subtitle="Mixing performance" />
    <Text text="Mixing dynamics in ÄKTA readyflux™ filtration system with a 5 L 2D bag and tubes has been evaluated experimentally and with computation fluid dynamics (CFD). Velocity vectors from CFD data show very good circulation in the bag to support homogenous mixing." />
    <Text text="Homogenous mixing was achieved experimentally in estimated 20 to 25 s at 1 slpm and 45 to 50 s at 2.5 slpm" />
    <Spacer />
    <Video src={mixinig_video} />
    <TextSmall text="Video showing CFD mixing at 2.5 L/m (2&#215; speed) in 5 L bag Average CFD mixing time in the bag, T95: 22.6s" />
    <Spacer x={2} />
  </>
);
export const ExternalMixer = () => (
  <>
    <Text text="The Xcellerex™ XDUO mixers are compatible with the ÄKTA readyflux™ system and can be connected and controlled through UNICORN™ control software. " />
    <Text text="Three Xcellerex™ XDUO mixers can be connected, functioning as a feed mixer, transfer and permeate mixer." />
    <Text text="XDUO must have weight support and a PROFIBUS connection to work with the ÄKTA readyflux™ system" />
    <Text text="Other external mixers can be used as a weighing scale if they have 4 to 20 mA output." />
    <Spacer x={2} />
  </>
);

export const Mixing: React.FC = () => {
  return (
    <>
      <div className="c-sidebar__body">
        <SubHotspots sublinkId="2-4" />
      </div>
    </>
  );
};
